<template>

    <Dialog :visible.sync="showDialog" :closable="false" :modal="true" :containerStyle="{ width: '60%' }" @hide="hideDialog">
          <Panel class="p-0 ">
            <template #header>
              <h5> Gabaritos </h5>
            </template>
            <transition-group name="p-messages" tag="div" class="col-12 md:col-12">
                <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{msg.content}}</Message>
            </transition-group>
            <DataTable :value="gabaritos" :selection.sync="gabaritoSelecionado" class="m-5 ml-0 mr-0 mb-0">
              <Column header="#" :headerStyle="{ width: '3rem' }">
                <template #body="slotProps">
                  {{ slotProps.index + 1 }}
                </template>
              </Column>
              <Column field="nomeArea" header="Área" sortable :headerStyle="{ width: '19rem' }"></Column>
              <Column header="Situacao" sortable>
                <template #body="slotProps">
                  {{ slotProps.data.gabaritoId ? "Informado" : "Não Informado" }}
                </template>
              </Column>
              <Column>
                <template #body="slotProps">
                    <input :id="'gabarito_'+slotProps.data.selecaoAreaId" type="file" @change="onFileSelected" required="true" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
                </template>
              </Column>
              <Column>
                <template #body="slotProps">
                    <Button label="Enviar" icon="pi pi-file-o" class="p-button" @click="enviarGabarito(slotProps.data)"/>
                </template>
              </Column>
            </DataTable>
          </Panel>
          <template #footer>
            <Button
              label="Fechar"
              icon="pi pi-times p-button-secondary"
              class=" p-button-secondary"
              @click="hideDialog"
              autofocus
            />
          </template>
    </Dialog>

    </template>

    <script>

import InscricaoService from '../../service/InscricaoService';
import ProvaService from '../../service/ProvaService';
import { tratamentoDeErros } from "@/tratamentoDeErros";

    export default {
        mixins: [tratamentoDeErros],
        props: {
            gabaritosDialog: null,
            processoSeletivo: null,
        },
        data() {
            return {
              showDialog: false,
              // estrutura objetos
              salasIndividuais: 0,
              gabaritos: [],
              arquivos: [],
              arquivoSelecionado: null,
              gabaritoSelecionado: null,
              messages: []
            };
        },
        created() {
            this.inscricaoService = new InscricaoService();
            this.provaService = new ProvaService();
        },
        mounted() {

        },
        watch :{
          gabaritosDialog: function(val) {
            this.messages = [];
            this.showDialog = val;
            this.listarGabaritos();
          },
        },
        methods: {
          hideDialog() {
            this.$emit('update:gabaritosDialog', false);
            this.showDialog = false;
          },
          listarGabaritos() {
            this.provaService.gerarResultado(this.processoSeletivo.id)
                    .then((gabaritos) => {
                        this.gabaritos = gabaritos;
                        this.$store.state.dlgLoading = false;
                    });
          },
          onFileSelected(event){
            console.log(event);
            this.arquivos[event.target.id] = event.target.files[0];
          },
          enviarGabarito(gabarito) {
            this.messages = [];
            this.$store.state.dlgLoading = true;
            let arquivo = this.arquivos['gabarito_'+gabarito.selecaoAreaId];
            this.provaService.importarGabarito(this.processoSeletivo.id, gabarito.selecaoAreaId, arquivo)
                    .then(() => {
                        this.listarGabaritos();
                        this.$toast.add({
                            severity: "success", summary: "Sucesso", detail: `Gabarito importado com sucesso.`, life: 5000,
                        });
                    })
                    .catch((erro) => {
                        this.messages = this.getMessagesError(erro);
                        this.$store.state.dlgLoading = false;
                    });
          }
        }
    }

    </script>

    <style></style>